import React from 'react';

export const Loader: React.FC<{ size?: 'sm' | 'md' | 'lg'; label?: string }> = ({ 
  size = 'md',
  label = 'Loading content'
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4',
  };

  return (
    <div className="flex items-center justify-center" role="status" aria-label={label}>
      <div
        className={`${sizeClasses[size]} border-gray-200 border-t-primary-500 rounded-full animate-spin`}
        aria-hidden="true"
      />
      <span className="sr-only">{label}</span>
    </div>
  );
};

export default Loader;